import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical, X } from 'lucide-react';
import { Button } from './ui/button';

interface SortableInterestItemProps {
  interest: {
    _id: string;
    name: string;
    icon_url?: string;
  };
  order: number;
  onRemove?: (interestId: string) => void;
  isReadOnly?: boolean;
}

export const SortableInterestItem: React.FC<SortableInterestItemProps> = ({ 
  interest, 
  order, 
  onRemove,
  isReadOnly = false 
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ 
    id: interest._id,
    disabled: isReadOnly 
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div 
      ref={setNodeRef} 
      style={style}
      className="flex items-center justify-between p-2 hover:bg-gray-50 rounded border bg-white"
    >
      <div className="flex items-center gap-2">
        {!isReadOnly && (
          <div
            {...attributes}
            {...listeners}
            className="cursor-grab hover:cursor-grabbing"
          >
            <GripVertical className="h-4 w-4 text-gray-400" />
          </div>
        )}
        <span className="text-sm font-medium">{order + 1}.</span>
        {interest.icon_url && (
          <img
            src={interest.icon_url}
            alt={interest.name}
            className="w-6 h-6 object-contain"
          />
        )}
        <span className="text-sm">{interest.name}</span>
      </div>
      {onRemove && !isReadOnly && (
        <Button
          size="sm"
          variant="ghost"
          onClick={() => onRemove(interest._id)}
        >
          <X className="h-3 w-3" />
        </Button>
      )}
    </div>
  );
};